export const LANGUAGE_LEVELS = [
    'Beginner',
    'Intermediate',
    'Proficient',
    'Native',
];
